import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';
import { setModal } from 'modules/_shared/redux/modalActions';
import Button from 'modules/_shared/components/Buttons';

import EquityMarketTermsByDefault from '../../pages/EquityMarketTerms/components/EquityMarketTermsByDefault';
import EquityMarketTermsByTemplate from '../../pages/EquityMarketTerms/components/EquityMarketTermsByTemplate';

type EquityMarketTermsModalProps = {
  size?: string;
};

const EquityMarketTermsModal: FC<EquityMarketTermsModalProps> = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    ({ society }: State) => society?.actualSociety
  );

  const termsTemplateId =
    actualSociety?.templates?.equityMarketTermsAndConditions;
  const hasTermsAndConditionsTemplate = !!termsTemplateId;

  const handleClose = () => {
    dispatch(setModal(null));
  };

  return (
    <>
      <Modal.Header className="border-bottom">
        <Modal.Title className="mb-0">
          {t('OfferConditionsPageTitle')}
        </Modal.Title>
        <a
          className="close cursor-pointer"
          onClick={handleClose}
          aria-label={t('Close')}
        >
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body>
        <p className="text-soft mb-4">{t('OfferConditionsPageDescription')}</p>

        {hasTermsAndConditionsTemplate && termsTemplateId ? (
          <EquityMarketTermsByTemplate templateId={termsTemplateId} />
        ) : (
          <EquityMarketTermsByDefault />
        )}
      </Modal.Body>

      <Modal.Footer className="border-top bg-lighter">
        <Button onClick={handleClose}>{t('Close')}</Button>
      </Modal.Footer>
    </>
  );
};

export default EquityMarketTermsModal;
